import React from "react";

import sublinks from "./data";

import extraSublinks from "./extraSublinks";

const ELearningProvider = React.createContext();

const Context = ({ children }) => {

  //State Values and functions

  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const [isSubmenuOpen, setIsSubmenuOpen] = React.useState(false);

  const [page, setPage] = React.useState({ page: "", links: [] });

  const [label, setLabel] = React.useState({label:"", subMenus:[]});

  const [extraSubmenu, setExtraSubmenu] = React.useState(false);

  const [location, setLocation] = React.useState({});

  //Functions

  const sideBarOpen = () => {

    setIsSidebarOpen(true);

  };

  const sideBarClosed = () => {

    setIsSidebarOpen(false);

  };



  const submenuClosed = () => {

    setIsSubmenuOpen(false)

  }

  const showSubmenu = (text, coordinates) =>{

    const page = sublinks.find((link) => link.page === text)

    setPage(page)

    setLocation(coordinates)

    setIsSubmenuOpen(true);

  }

  const submenuOfSubmenus = (text, coordinates) =>{

    const label = extraSublinks.find((extraSublink) => extraSublink.label === text)

    setLabel(label)

    setLocation(coordinates)

    setExtraSubmenu(true)

  }

  const closeExtraSubmenu = () =>{

    setExtraSubmenu(false)
    
  }






  return (
    <ELearningProvider.Provider
      value={{
        isSidebarOpen,
        isSubmenuOpen,
        sideBarOpen,
        sideBarClosed,
        isSubmenuOpen,
        submenuClosed,
        showSubmenu,
        label,
        submenuOfSubmenus,
        closeExtraSubmenu,
        extraSubmenu,
        page,
        location,

      }}
    >
      {children}
    </ELearningProvider.Provider>
  );
};

export const MyCustomContextHook = () =>{

    return React.useContext(ELearningProvider)
    
};

export {ELearningProvider, Context};
